/**
 * @Author     : Fanng(fanng@live.com)
 * @CreateTime : 28/3/2017 11:16 AM
 */
import axios from "axios";
// import * as Cookies from 'js-cookie';
// import {MessageBox} from 'element-ui';
// export const baseURL = process.env.NODE_ENV === "production" ? "https://p.711.cn/api/" : "http://127.0.0.1:9998/api/";
export const baseURL = process.env.NODE_ENV === "production" ? "https://p.711.cn/api/" : "https://p.711.cn/api/";
var http = axios.create({
    baseURL: baseURL,
    withCredentials: true,
});
http.defaults.headers.common = {
    "X-ORG-ID": window.config.org_id,
};
http.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        const { response } = error;
        if (typeof response != "undefined") {
            if (response.status == 200) {
                return response.data;
            } else {
                return {};
            }
        } else {
            return {};
        }
    }
);

export default http;
